export enum DiscoverRouteTypeEnum {
    /** Saved Searches Hype Page */
    targetingSearchHype,

    /** Discover Contact "hype page" - blank edit search form */
    targetingSearch,

    /** Unsaved search - edit search form */
    targetingSearchUpdate,

    /** Unsaved search - results page */
    targetingResults,

    /** Saved Search - edit search form */
    targetingSavedSearch,

    /** Saved Search - results page */
    targetingSavedSearchResults,

    targetingListHype,
    targetingListSearchResult,
    privateContacts,
    discoverContacts,
    csvImport,
    contactEditor,
    distributionHype,
    // Unsaved draft distribution
    distributionNew,
    // NewDistribution component for selecting what sort of distribution to start
    newDistribution,
    distributionEdit,
    distributionReport,
    distributionDashboard,
    contactProfile,
    outletProfile,
    influencerStreams,
    portfolioResults,
    visibilityIntelHype
}
